import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import Workspace from "@/pages/Workspace";
import AuthCallback from "@/pages/AuthCallback";
import PreviewPage from "@/pages/PreviewPage";
import PaymentReturn from "@/pages/PaymentReturn";
import AdminPage from "@/pages/AdminPage";
import { CheckoutProvider } from "@/context/CheckoutContext";

function AppRouter() {
  const location = useLocation();
  // Detect the OAuth fragment synchronously so the session exchange runs before any /auth/me check.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/preview/:slug" element={<PreviewPage />} />
      <Route path="/payment/success" element={<PaymentReturn />} />
      <Route path="/payment/cancel" element={<PaymentReturn />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={<Workspace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <CheckoutProvider>
          <AppRouter />
        </CheckoutProvider>
        <Toaster theme="dark" position="bottom-right" richColors />
      </AppProvider>
    </BrowserRouter>
  );
}

export default App;
